import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EForm } from '../e-form.model';
import { EFormService } from '../e-form.service';
import * as _ from 'lodash';

@Component({
	selector: 'app-e-form-notes',
	templateUrl: './e-form-notes.component.html',
	// styleUrls: ['./e-form-notes.component.scss']
})
export class EFormNotesComponent implements OnInit {

	eForm: EForm;
	note = '';

	constructor(
		private dialog: MatDialogRef<EFormNotesComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private eFormService: EFormService
	) {
		this.eForm = _.cloneDeep(this.data.eForm);
		this.note = this.eForm.StaffNote;
	}

	ngOnInit() {

	}

	saveClick() {
		this.eForm.StaffNote = this.note;
		// this.eFormService.saveEForm(this.eForm).subscribe();
		this.dialog.close(this.eForm);
	}

	closeClick() {
		this.dialog.close();
	}

}
